





















































import {Component, Vue} from 'vue-property-decorator';
import CDeleteDialog from '@/components/base/dialog/CDeleteDialog.vue';
import PlanEditResultEditConfigFlexGridEditDialog from '@/views/journals/planEdit/planEditTabs/result/edit/PlanEditResultEditConfigFlexGridEditDialog.vue';
import {mapActions, mapMutations, mapState} from 'vuex';
import PlanEditResultModel, {PlanEditResultCurrentConfig} from '@/models/PlanEditResultModel';
import {parseToDescriptions} from '@/utils';
import config from '@/configs/PlanEditResultConfig';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
@Component({
    components: {CSimpleTable, PlanEditResultEditConfigFlexGridEditDialog, CDeleteDialog},
    computed: {
        ...mapState('planEditResult', ['result', 'currentConfig']),
    },
    methods: {
        ...mapMutations('planEditResult', ['setResultConfigsDescriptions', 'setCurrentConfig']),
        ...mapActions('planEditResult', ['setResultConfig']),
    },
})
export default class PlanEditResultEditConfigFlexGrid extends Vue {
    private loading = false;
    private data: any = null;
    public result!: PlanEditResultModel;
    public currentConfig!: PlanEditResultCurrentConfig | null;
    public setCurrentConfig!: Function;
    public setResultConfig!: Function;
    public setResultConfigsDescriptions!: Function;

    get items() {
        return this.data?.Data.Items;
    }
    set items(value) {
        this.data.Data.Items = value;
    }

    created() {
        this.getData();
    }

    async getData() {
        this.loading = true;
        try {
            const {data} = await this.$http.get('resultConfig/getAll');
            this.data = data;
            this.setResultConfigsDescriptions(parseToDescriptions(data.Data.Items));
        } finally {
            this.loading = false;
        }
    }

    async onAdd() {
        try {
            const {data} = await this.$http.get('resultConfig/getCreate');
            (this.$refs.editDialog as any).open(data, {
                title: this.$t('Common.Add'),
                type: 'add',
                saveCallback: async (payload: any) => {
                    try {
                        const data = await this.save(payload);
                        this.data = data;
                        this.setResultConfigsDescriptions(parseToDescriptions(data.Data.Items));
                    } finally {
                        (this.$refs.editDialog as any).close();
                    }
                },
            });
        } catch {}
    }
    onDeleteAll() {
        (this.$refs.deleteDialog as any).open(null, {
            deleteCallback: async () => {
                try {
                    const {data} = await this.$http.post('resultConfig/deleteAll');
                    if (data.Dependencies) (this.$refs.deleteDialog as any).error(data.Dependencies);
                    else {
                        this.data = data;
                        this.setResultConfigsDescriptions(parseToDescriptions(data.Data.Items));
                        (this.$refs.deleteDialog as any).close();
                    }
                } catch {
                    (this.$refs.deleteDialog as any).close();
                }
            },
        });
    }
    async onEdit(id: number) {
        try {
            const {data} = await this.$http.get('resultConfig/getEdit', {
                params: {
                    id,
                },
            });
            (this.$refs.editDialog as any).open(data, {
                title: this.$t('Common.Edit'),
                type: 'edit',
                saveCallback: async (payload: any) => {
                    try {
                        const data = await this.save(payload);
                        this.data = data;
                        this.setResultConfigsDescriptions(parseToDescriptions(data.Data.Items));
                        if (this.currentConfig?.Id === id) {
                            this.setCurrentConfig(payload);
                        }
                    } finally {
                        (this.$refs.editDialog as any).close();
                    }
                },
            });
        } catch {}
    }
    onDelete(id: number) {
        (this.$refs.deleteDialog as any).open(id, {
            deleteCallback: async (id: number) => {
                try {
                    const {data} = await this.$http.post('resultConfig/delete', null, {
                        params: {
                            id,
                        },
                    });
                    if (data.Dependencies) {
                        (this.$refs.deleteDialog as any).error(data.Dependencies);
                    } else {
                        this.data = data;
                        this.setResultConfigsDescriptions(parseToDescriptions(data.Data.Items));
                        (this.$refs.deleteDialog as any).close();
                    }
                } catch {
                    (this.$refs.deleteDialog as any).close();
                }
            },
        });
    }
    async onCopy(id: number) {
        try {
            const {data} = await this.$http.get('resultConfig/getCopy', {
                params: {
                    id,
                },
            });
            if (id === -1) data.Value = JSON.stringify(config);
            (this.$refs.editDialog as any).open(data, {
                title: this.$t('Common.Copy'),
                type: 'copy',
                saveCallback: async (payload: any) => {
                    try {
                        const data = await this.save(payload);
                        this.data = data;
                        this.setResultConfigsDescriptions(parseToDescriptions(data.Data.Items));
                    } finally {
                        (this.$refs.editDialog as any).close();
                    }
                },
            });
        } catch {}
    }
    async onSelect(id: number) {
        if (this.currentConfig?.Id === id) return;
        this.setResultConfig({idResult: this.result.Id, idResultConfig: id});
    }
    async save(payload: any) {
        try {
            const {data} = await this.$http.post('resultConfig/save', payload);
            return data;
        } finally {
            (this.$refs.editDialog as any).close();
        }
    }
}
